import ImageMarquee from './ImageMarquee'

export default ImageMarquee